import { UsersAndUserGroupsDataModel } from "../UserGroupsManagement/userGroupsManagement";
import { environmentHttpClient } from "client/Api/httpClient";

export enum CanManageUserActivateStatusKind {
	NotAllowed = 0,
	Allowed = 1,
	IsManagedInAzureAD = 2
};

export type UserLicensingPageModel = {
	canManageUserActiveStatusInWorkspace: CanManageUserActivateStatusKind;
	usersAndUserGroupsData: UsersAndUserGroupsDataModel;
};

export function getPageModel(
	signal?: AbortSignal
): Promise<UserLicensingPageModel> {
	return environmentHttpClient.get<UserLicensingPageModel>(
		"/UiApi/UserLicensingManagement",
		undefined,
		{ signal }
	);
}

export function activateUsers(
	userIds: readonly number[],
	signal?: AbortSignal
): Promise<UsersAndUserGroupsDataModel> {
	return environmentHttpClient.put<UsersAndUserGroupsDataModel>(
		"/UiApi/UserLicensingManagement/ActivateUsers",
		userIds,
		{ signal }
	);
}

export function deactivateUsers(
	userIds: readonly number[],
	signal?: AbortSignal
): Promise<UsersAndUserGroupsDataModel> {
	return environmentHttpClient.put<UsersAndUserGroupsDataModel>(
		"/UiApi/UserLicensingManagement/DeactivateUsers",
		userIds,
		{ signal }
	);
}

export function activateGroups(
	groupIds: readonly number[],
	signal?: AbortSignal
): Promise<UsersAndUserGroupsDataModel> {
	return environmentHttpClient.put<UsersAndUserGroupsDataModel>(
		"/UiApi/UserLicensingManagement/ActivateGroups",
		groupIds,
		{ signal }
	);
}

export function deactivateGroups(
	groupIds: readonly number[],
	signal?: AbortSignal
): Promise<UsersAndUserGroupsDataModel> {
	return environmentHttpClient.put<UsersAndUserGroupsDataModel>(
		"/UiApi/UserLicensingManagement/DeactivateGroups",
		groupIds,
		{ signal }
	);
}
